<script lang="ts">
  import QualityLayout from "../../layout/QualityLayout.svelte";
</script>

<QualityLayout>
  <h1 class="title">Procedure Qualità</h1>

  <div class="tile is-ancestor quality-procedure-tiles">
    <div class="tile is-vertical is-4">
      <div class="tile">
        <div class="tile is-parent is-vertical">
          <a class="tile is-child notification" href="/quality-sanification">
            <p class="subtitle">Sanificazione</p>
          </a>
          <a class="tile is-child notification" href="/quality-infest">
            <p class="subtitle">Infestanti</p>
          </a>
          <a class="tile is-child notification" href="/quality-h2o">
            <p class="subtitle">H2O</p>
          </a>
          <a class="tile is-child notification" href="/quality-analysis">
            <p class="subtitle">Analisi</p>
          </a>
          <a class="tile is-child notification" href="/quality-schedule-maintenance">
            <p class="subtitle">Scadenziario Manutenzioni</p>
          </a>
        </div>
      </div>
    </div>
    <div class="tile is-vertical is-4">
      <div class="tile">
        <div class="tile is-parent is-vertical">
          <a class="tile is-child notification" href="/quality-external-maintenance">
            <p class="subtitle">Manutenzioni Esterne</p>
          </a>
          <a class="tile is-child notification" href="/quality-internal-maintenance">
            <p class="subtitle">Manutenzioni Interne</p>
          </a>
          <a class="tile is-child notification" href="/quality-calibration">
            <p class="subtitle">Tarature</p>
          </a>
          <a class="tile is-child notification" href="/quality-welfare">
            <p class="subtitle">Benessere</p>
          </a>
          <a class="tile is-child notification" href="/quality-incident">
            <p class="subtitle">Non conformità</p>
          </a>
        </div>
      </div>
    </div>
    <div class="tile is-vertical is-4">
      <div class="tile">
        <div class="tile is-parent is-vertical">
          <a class="tile is-child notification" href="/quality-waste">
            <p class="subtitle">Smaltimento</p>
          </a>
          <a class="tile is-child notification" href="/quality-training">
            <p class="subtitle">Formazione</p>
          </a>
          <a class="tile is-child notification" href="/quality-atp">
            <p class="subtitle">ATP</p>
          </a>
          <a class="tile is-child notification" href="/quality-schedule-analysis">
            <p class="subtitle">Scadenziario Analisi</p>
          </a>
        </div>
      </div>
    </div>
  </div>
</QualityLayout>

<style>
  .quality-procedure-tiles .tile.is-child {
    background-color: #9e0a11;
    color: #ffffff;
    cursor: pointer;
  }
</style>
